import { Button, Modal } from "react-bootstrap";
import "./upload-again.modal.scss";

interface RoomProps {
    isOpen: boolean
    onClose(): void
    submit(): void
}

const UploadAgainModal: React.FC<RoomProps> = ({ isOpen, onClose, submit }) => {
  
    return (
        <>
            <Modal show={isOpen} onHide={onClose} backdrop="static" centered>

                <Modal.Body className="upload-again-control">
                    <div className="upload-again-content">
                         <span className="title">เกิดข้อผิดพลาด กรุณากดส่งคำตอบอีกครั้ง</span>

                         <Button className="button-std button-submit-again" onClick={submit}>ส่งคำตอบอีกครั้ง</Button>
                    </div>
                   
                    
                </Modal.Body>

            </Modal>
        </>
    )
}

export default UploadAgainModal;